<form>
  <div class="mb-3">
    <label for="notes" class="my-1"><strong>ADDITIONAL DETAILS </strong>({{ additionalDetailsRequired ? "Required" : "Optional" }})</label>
    <textarea
      id="notes"
      name="notes"
      class="form-control phi"
      rows="3"
      [(ngModel)]="formModel.notes"
      (change)="onNotesChange()"
      [disabled]="formDisabled || task.frozen"
      >
    </textarea>
  </div>
  <div [hidden]="!consultNoteTaskCreationAllowed" class="mb-3">
    <div class="form-check">
      <input
        id="collectConsultNote"
        name="collectConsultNote"
        class="form-check-input"
        type="checkbox"
        [(ngModel)]="formModel.collectConsultNote"
        />
      <label for="collectConsultNote" class="form-check-label">
        <small>
          I have a relevant consult note for this patient and prescriber, and I would like to complete the consult note
          task following submission of this task. <br />NOTE: If you do not select this option, NuvemRx will attempt to
          collect the consult note for you.
        </small>
      </label>
    </div>
  </div>
</form>
@if (serverError) {
  <div class="mb-3">
    <div class="alert alert-danger p-2">{{ serverErrorMsg }}</div>
  </div>
}
<div class="d-flex justify-content-end align-items-center mt-2">
  @if (submitLoading || nextLoading) {
    <div style="display: inline-block;">
      <mat-spinner diameter="20" />
    </div>
  }
  @if (submitAllowed) {
    <button class="btn btn-primary ms-2" [disabled]="!submitEnabled || submitLoading" (click)="onSubmitClick($event)">
      <fa-icon [icon]="['fas', 'cloud-upload-alt']" />Submit to NuvemRx
    </button>
  }
  @if (nextButtonEnabled) {
    <button class="btn btn-secondary ms-2" [disabled]="nextLoading" (click)="onNextClick($event)">
      Next <fa-icon [icon]="['fas', 'angle-double-right']" />
    </button>
  }
</div>
